import { ESID_HELP } from "@/lib/disclosureTexts";

/**
 * "Where To Find Your ESID": static help text for the Texas landing (Design Spec F4). Tells the customer RateCurrent's
 * ESID lookup tool can usually find it automatically from their address, with the bill/"ESI ID" label as the fallback.
 * No example number, no lookup link (see draft2's own version note in lib/disclosureTexts.js). The words are CLO's,
 * versioned in lib/disclosureTexts.js (DRAFT).
 */
export default function EsidHelp() {
  return (
    <details className="mt-10 border border-slate-200 rounded-xl p-4 max-w-[65ch]" data-testid="esid-help" data-text-version={ESID_HELP.id} data-text-status={ESID_HELP.status}>
      <summary className="cursor-pointer font-semibold text-[#0A2540]">{ESID_HELP.heading}</summary>
      <p className="mt-3 text-slate-700">{ESID_HELP.primary}</p>
    </details>
  );
}
